export enum StarType {
  FILLED = 'rating-filled',
  HALF = 'rating-half',
  EMPTY = 'rating-empty',
}
